import React from 'react';

export default function CowTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="20.91,5.26 16.69,5.26 15.84,2.0 20.05,2.0" fill="#775857" />
      <polygon points="16.69,5.26 20.91,5.26 17.5,14.92 13.28,14.92" fill="#3C2C2B" opacity="0.95" />
      <polygon points="16.69,5.26 13.28,14.92 12.43,11.65 15.84,2.0" fill="#3C2C2B" opacity="0.95" />
      <polygon points="24.47,23.66 20.46,23.66 20.0,19.72 24.01,19.72" fill="#775857" />
      <polygon points="20.46,23.66 24.47,23.66 20.02,27.58 16.01,27.58" fill="#3C2C2B" opacity="0.95" />
      <polygon points="20.46,23.66 16.01,27.58 15.55,23.64 20.0,19.72" fill="#3C2C2B" opacity="0.95" />
      <polygon points="27.57,38.0 21.55,38.0 21.55,31.98 27.57,31.98" fill="#775857" />
      <polygon points="21.55,38.0 27.57,38.0 24.56,36.49 18.53,36.49" fill="#3C2C2B" opacity="0.95" />
      <polygon points="21.55,38.0 18.53,36.49 18.53,30.47 21.55,31.98" fill="#3C2C2B" opacity="0.95" />
      <polygon points="27.27,37.3 23.05,37.3 23.05,33.28 27.27,33.28" fill="#775857" />
      <polygon points="23.05,37.3 27.27,37.3 23.65,35.49 19.44,35.49" fill="#3C2C2B" opacity="0.95" />
      <polygon points="23.05,37.3 19.44,35.49 19.44,31.48 23.05,33.28" fill="#3C2C2B" opacity="0.95" />
    </svg>
  );
}
